export { default } from "./Tabs.mjs";
export { default as tabsClasses } from "./tabsClasses.mjs";
export * from "./tabsClasses.mjs";